export default function PlaceholderArea({ title, description, testId }) {
  return (
    <div className="border border-ink/15 bg-white/30 rounded-lg p-10 text-center" data-testid={testId}>
      <h2 className="font-serif text-xl text-ink mb-2">{title}</h2>
      <p className="text-ink-soft text-sm max-w-md mx-auto">{description}</p>
    </div>
  );
}
